<template>
  <transition name="el-fade-in">
    <div v-show="visible && !isLiked" class="hover-modal" @click.self="visible = false">
      <div class="hover-dialog">
        <div style="height:98vh;width: 168px;overflow-y:auto;overflow-x:hidden;">
          <p class="el-icon" @click="visible = false"><i class="el-icon-close" /></p>
          <div v-for="(child, i) in item" :key="child.name + i" class="hover-content">
              <template
                v-if="
                  !(
                    child.children &&
                    Array.isArray(child.children) &&
                    child.children.filter(e => !e.hidden).length
                  )
                "
              >
                <div class="title-item hover" :title="generateTitle(child.name)">
                  <Item
                    v-if="child.meta"
                    :right-icon="isLike(child.name) ? `el-icon-star-on` : `el-icon-star-off`"
                    :title="generateTitle(child.name)"
                    @titleClick="toRoute(child)"
                    @iconClick="handleClickIcon(child)"
                  />
                </div>
              </template>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import path from 'path';
import { isExternal } from '@/utils/validate';
import Item from './Item';
import { generateTitle } from '@/utils/i18n';

export default {
  components: { Item },
  props: {
    likedData: {
      type: Array,
      default: () => [],
    },
    isLiked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      code: 'myLikeMenuList',
      visible: false,
      item: null,
      myLikeMenu2RouteArray: [],
      labelsVersion: 11,
    };
  },
  mounted() {
    // 注册刷新事件
    this.$eventHub.$on('showSecondaryMenu', this.showSecondaryMenu);
  },
  methods: {
    showSecondaryMenu(item) {
      if (!item || !Array.isArray(item)) {
        this.visible = false;
        this.item = [];
        return;
      }
      this.visible = true;
      this.item = item;
    },

    resolvePath(routePath, basePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(basePath)) {
        return basePath;
      }
      return path.resolve(basePath, routePath);
    },
    toRoute(route) {
      const externalUrl = route.meta && route.meta.externalUrl;
      if (externalUrl) {
        window.open(externalUrl, '_blank', 'noopener');
        this.visible = false;
        return;
      }

      this.$router.push({
        name: route.name,
      });
      this.visible = false;
    },
    handleClickIcon(route) {
      const name = route.name;
      // 原来是收藏状态
      if (this.isLike(name)) {
        // 点击为 去除收藏
        // this.myLikeMenu2RouteArray.remove(name, 'name');
        this.$store.commit('app/DELETE_SIDEBAR_LIKED_DATA', route);
      } else {
        // this.myLikeMenu2RouteArray.push({
        //   ...route,
        // });
        this.$store.commit('app/ADD_SIDEBAR_LIKED_DATA', route);
      }
      this.$nextTick(() => {
        this.$store.dispatch('app/saveLikeData');
      });
    },
    isLike(name) {
      return this.likedData.find(e => e.name == name);
    },
    generateTitle
  },
};
</script>
<style lang="scss" scoped>
@import '~@/styles/variables.scss';
.hover-modal {
  width: calc(100% - #{$sideBarWidth});
  height: 100%;
  position: fixed;
  top: 0;
  left: $sideBarWidth;
  transform-origin: left center;
  z-index: 2001;
  background: rgba(0, 0, 0, 0.2);
}
.hideSidebar .hover-modal {
  left: $sideBarWidthHide;
  width: calc(100% - #{$sideBarWidthHide});
}
.hover-dialog {
  background: #ffffff;
  padding: 12px;
  color: #606266;
  line-height: 1.4;
  text-align: justify;
  font-size: 14px;
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  word-break: break-all;
  width: 180px;
  height: 100%;
  position: relative;
}

// .hover-dialog > div {
//   display: flex;
//   flex-direction: row;
//   width: 100%;
//   flex-wrap: wrap;
// }
.hover-dialog .hover-content {
  // max-height: calc(100% - 30px);
  // overflow-y: auto;
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
}
.hover-dialog .hover-content .hover-col {
  width: 25%;
}
.hover-dialog .hover-item {
  width: 100%;
  line-height: 2;
  margin-bottom: 16px;
  .title {
    font-weight: bold;
    font-size: 13px;
    color: $main-dark;
    display: inline-block;
    width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.title-item {
  font-size: 14px;
  line-height: 36px;
  padding: 0 0 0 10px;
}
.hover-dialog .hover-item:last-child {
  margin-bottom: 0;
}
.el-icon {
  text-align: right;
  padding: 0;
  margin: 0;
}
.el-icon-close {
  font-size: 20px;
  padding: 8px;
  cursor: pointer;
}
.pointer {
  cursor: pointer;
}
.hover:hover {
  color: $minor-dark;
  background-color: $background-dark;
}
.isEmpty.hover:hover {
  color: #c0c4cc;
  text-decoration: none;
}
.isEmpty.hover {
  color: #c0c4cc;
}
</style>
